import _extends from '/app/node_modules/babel-runtime/helpers/extends';
import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _Promise from '/app/node_modules/babel-runtime/core-js/promise';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import debounce from 'debounce';
import { mapState, mapGetters, mapActions } from 'vuex';
import BoxAfiliations from '~/components/dashboard/box-afiliations';
import AffiliationsProcess from '~/components/dashboard/affiliations-process';
import AffiliationsWorked from '~/components/dashboard/affiliations-worked';
import RankingTable from '~/components/dashboard/ranking-table';
import loader from '~/components/modals/loader';
import Doughnut from '~/components/dashboard/dougthnut';
import BarChart from '~/components/dashboard/barchart';
import Loader from '~/components/modals/loader';

export default {
    fetch: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
            var store = _ref.store,
                app = _ref.app,
                params = _ref.params;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            store.commit('dashboard/details/setToolbarTitle', 'Dashboard');
                            _context.prev = 1;
                            _context.next = 4;
                            return _Promise.all([store.dispatch('dashboard/details/listSellers'),
                            // store.dispatch('dashboard/filters/findProductType'),
                            // store.dispatch('dashboard/filters/findAllDepartment'),
                            store.dispatch('dashboard/table/getDashboardData'), store.dispatch('dashboard/details/listChannels')]
                            // store.dispatch('notification/getNotificationsCount'),
                            );

                        case 4:
                            _context.next = 9;
                            break;

                        case 6:
                            _context.prev = 6;
                            _context.t0 = _context['catch'](1);

                            app.$controlMessage(_context.t0);

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 6]]);
        }));

        function fetch(_x) {
            return _ref2.apply(this, arguments);
        }

        return fetch;
    }(),

    components: {
        BoxAfiliations: BoxAfiliations,
        AffiliationsProcess: AffiliationsProcess,
        AffiliationsWorked: AffiliationsWorked,
        RankingTable: RankingTable,
        loader: loader,
        Doughnut: Doughnut,
        BarChart: BarChart,
        Loader: Loader
    },
    computed: _extends({}, mapState({
        user: function user(state) {
            return state.user;
        },
        currentAffiliations: function currentAffiliations(state) {
            return state.dashboard.table.currentAffiliations;
        },
        graphicNumbersData: function graphicNumbersData(state) {
            return state.dashboard.table;
        },
        posFijo: function posFijo(state) {
            return state.dashboard.table.posFijo;
        },
        pagoApp: function pagoApp(state) {
            return state.dashboard.table.pagoApp;
        },
        pagoWeb: function pagoWeb(state) {
            return state.dashboard.table.pagoWeb;
        },
        posInalam: function posInalam(state) {
            return state.dashboard.table.posInalam;
        },
        notificationCount: function notificationCount(state) {
            return state.notification.notificationCount;
        }
    }), mapGetters('user', ['isAdmin', 'isBoss', 'isSeller', 'isSupervisor']), {
        onResize: function onResize() {
            if (window.innerWidth <= 1024 && window.innerWidth > 768) {
                this.barWidth = 1100;
                this.barHeight = 100;
            } else if (window.innerWidth <= 1200 && window.innerWidth > 1024) {
                this.barWidth = 1100;
                this.barHeight = 200;
            } else if (window.innerWidth <= 768 && window.innerWidth > 650) {
                this.barWidth = 1100;
                this.barHeight = 400;
            } else if (window.innerWidth <= 600 && window.innerWidth > 480) {
                this.noContent = true;
                this.barHeight = 400;
            } else if (window.innerWidth <= 480) {
                this.noContent = true;
                this.barHeight = 590;
            } else {}
        }
    }),

    data: function data() {
        return {
            //Data de la Dona
            seller1: '',
            seller2: '',
            concretedBefore: '',
            team: '',
            //table data
            today: this.$moment().format('LL'),
            active: null,
            noContent: false,
            showStatisticsInMobile: false,
            barHeight: 550,
            barWidth: 970,
            noSelectTeam: true,
            noSelectSellers: true,
            polarData: null,
            products: [{ name: "POS Inalám" }, { name: "POS Fijo" }, { name: "Pago Web" }, { name: "Pago App" }, { name: "Pago Link" }],
            items: this.$store.getters['dashboard/details/sellers'],
            departmentsFilter: this.$store.getters['dashboard/filters/departments'],
            productsTypeFilter: this.$store.getters['dashboard/filters/productsType'],
            provinceSelect: this.$store.getters['dashboard/filters/province'],
            channels: this.$store.getters['dashboard/details/channels'],
            channel: '',
            teams: [],
            sellers: []
        };
    },
    created: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!this.channel) {
                                _context2.next = 4;
                                break;
                            }

                            _context2.next = 3;
                            return this.findTeamByChannel({ idChannel: this.channel });

                        case 3:
                            this.teams = _context2.sent;

                        case 4:
                            this.team = '';

                            if (!this.team) {
                                _context2.next = 9;
                                break;
                            }

                            _context2.next = 8;
                            return this.listSellers({ idChannel: this.channel, idTeam: this.team });

                        case 8:
                            this.sellers = _context2.sent;

                        case 9:
                            this.seller2 = '';

                        case 10:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function created() {
            return _ref3.apply(this, arguments);
        }

        return created;
    }(),

    methods: _extends({}, mapActions({
        findTeamByChannel: 'dashboard/details/findTeamByChannel',
        listSellers: 'dashboard/details/listSellers'
    }), {
        pagination: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(val) {
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                this.$store.commit('dashboard/table/setPagination', val);

                            case 1:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function pagination(_x2) {
                return _ref4.apply(this, arguments);
            }

            return pagination;
        }(),
        startAffiliation: function startAffiliation() {
            console.log("Entra al Clear previo");
            this.$store.commit('affiliations/form/finishAffiliation');
            console.log("Termina el Clear previo");
            this.$router.push('new-affiliation');
        },
        setIdSeller: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(val) {
                var _this = this;

                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                this.$refs.loaderModal.showLoader();
                                _context4.prev = 1;
                                _context4.next = 4;
                                return this.$store.commit('dashboard/details/setIdSeller', val);

                            case 4:
                                _context4.next = 6;
                                return this.$store.dispatch('dashboard/table/updateDataBySelectSeller', {
                                    idSeller: val
                                });

                            case 6:
                                _context4.next = 10;
                                break;

                            case 8:
                                _context4.prev = 8;
                                _context4.t0 = _context4['catch'](1);

                            case 10:
                                setTimeout(function () {
                                    _this.$refs.loaderModal.closeLoader();
                                }, 500);

                            case 11:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[1, 8]]);
            }));

            function setIdSeller(_x3) {
                return _ref5.apply(this, arguments);
            }

            return setIdSeller;
        }(),
        setIdSellerByTeam: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(val) {
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.prev = 0;
                                _context5.next = 3;
                                return this.$store.commit('dashboard/details/setIdSellerByTeam', val);

                            case 3:
                                _context5.next = 5;
                                return this.$store.dispatch('dashboard/table/updateDataByBossAdmin', {
                                    idChannel: this.$store.state.dashboard.details.idChannel || -1,
                                    idTeam: this.$store.state.dashboard.details.idTeam || -1,
                                    idSeller: val || -1,
                                    limit: 10,
                                    offset: 0
                                });

                            case 5:
                                _context5.next = 9;
                                break;

                            case 7:
                                _context5.prev = 7;
                                _context5.t0 = _context5['catch'](0);

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this, [[0, 7]]);
            }));

            function setIdSellerByTeam(_x4) {
                return _ref6.apply(this, arguments);
            }

            return setIdSellerByTeam;
        }(),
        leavingPage: function leavingPage() {
            this.$refs.loaderModal.showLoader();
        }
    }),
    watch: {
        channel: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id) {
                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                this.$refs.loaderModal.showLoader();
                                if (id !== -1) {
                                    this.noSelectTeam = false;
                                    this.noSelectSellers = true;
                                } else {
                                    this.noSelectTeam = true;
                                    this.noSelectSellers = true;
                                }
                                _context6.prev = 2;

                                this.$store.commit('dashboard/details/setIdChannel', id);
                                _context6.next = 6;
                                return this.findTeamByChannel({ channelId: id });

                            case 6:
                                this.teams = _context6.sent;


                                // await this.$store.dispatch('dashboard/table/updateDataByBossAdmin', {
                                //     idChannel: this.$store.state.dashboard.details.idChannel || -1,
                                //     idTeam: -1,
                                //     idSeller: -1
                                // })
                                this.team = '';
                                this.seller2 = '';
                                _context6.next = 14;
                                break;

                            case 11:
                                _context6.prev = 11;
                                _context6.t0 = _context6['catch'](2);

                                this.$controlMessage(_context6.t0);

                            case 14:
                                this.$refs.loaderModal.closeLoader();

                            case 15:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this, [[2, 11]]);
            }));

            function channel(_x5) {
                return _ref7.apply(this, arguments);
            }

            return channel;
        }(),
        team: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id) {
                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                this.$refs.loaderModal.showLoader();
                                if (id == -1 || id == '') {
                                    this.noSelectSellers = true;
                                } else {
                                    this.noSelectSellers = false;
                                }
                                _context7.prev = 2;

                                this.$store.commit('dashboard/details/setIdTeam', id);
                                _context7.next = 6;
                                return this.listSellers({ channelId: this.channel, teamId: id });

                            case 6:
                                this.sellers = _context7.sent;
                                _context7.next = 9;
                                return this.$store.dispatch('dashboard/table/updateDataByBossAdmin', {
                                    idChannel: this.$store.state.dashboard.details.idChannel || -1,
                                    idTeam: this.$store.state.dashboard.details.idTeam || -1,
                                    idSeller: -1
                                });

                            case 9:
                                this.seller2 = '';
                                _context7.next = 15;
                                break;

                            case 12:
                                _context7.prev = 12;
                                _context7.t0 = _context7['catch'](2);

                                this.$controlMessage(_context7.t0);

                            case 15:
                                this.$refs.loaderModal.closeLoader();

                            case 16:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this, [[2, 12]]);
            }));

            function team(_x6) {
                return _ref8.apply(this, arguments);
            }

            return team;
        }(),
        seller2: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(id) {
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                this.$refs.loaderModal.showLoader();
                                if (this.channel !== -1) {
                                    this.noSelectSellers = false;
                                } else {
                                    this.noSelectSellers = true;
                                }
                                _context8.prev = 2;
                                _context8.next = 5;
                                return this.$store.dispatch('dashboard/table/updateDataByBossAdmin', {
                                    idChannel: this.$store.state.dashboard.details.idChannel || -1,
                                    idTeam: this.$store.state.dashboard.details.idTeam || -1,
                                    idSeller: this.$store.state.dashboard.details.idSellerByTeam || -1
                                });

                            case 5:
                                this.$refs.loaderModal.closeLoader();

                                _context8.next = 11;
                                break;

                            case 8:
                                _context8.prev = 8;
                                _context8.t0 = _context8['catch'](2);

                                this.$controlMessage(_context8.t0);

                            case 11:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this, [[2, 8]]);
            }));

            function seller2(_x7) {
                return _ref9.apply(this, arguments);
            }

            return seller2;
        }(),
        barWidth: function barWidth(val) {
            // console.log(val)
        }
    },
    mounted: function mounted() {
        this.$store.dispatch('notification/getNotificationsCount');
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/dashboard/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/dashboard/index.vue
// module chunks = 5